import React, { useEffect, useState, useRef } from "react";
import style from "./deleteCargoModal.module.scss";
import Modal from '../../Modal/Modal'
import Button from '../../Button/button'
import CheckBox from "../../SelectionControls/Checkbox/Checkbox";


const DeleteCargoModal = (props) => {
    const [modalData, setModalData] = useState({
        channels: props.cargoConfigs ? props.cargoConfigs : [],
        selectedConfigs: [],
        selectedConfigsValues: [],
        status: 'unknown'
    })

    useEffect(async () => {
        if (props.cargoConfigs) {
            let tmp = modalData
            tmp.channels = props.cargoConfigs
            setModalData({ ...tmp })
        }
    }, [props])

    useEffect(() => {
        if (!props.show) {
            let temp = modalData
            temp.status = 'unknown'
            temp.selectedConfigs = []
            temp.selectedConfigsValues = []
            setModalData({ ...temp })
        }
    }, [props.show])

    const deleteCargoConfigFunction = async () => {
        let id = ''
        if (modalData.channels.length == 1) {
            id = [modalData.channels[0]._id]
        } else {
            id = modalData.selectedConfigsValues
        }
        let res = await props.deleteCargoConfigFunction(id)
        if (res.data && res.data.success) {
            let temp = modalData
            temp.status = 'success'
            setModalData({ ...temp })
        }
    }

    const handleCheckBox = (e, value, tag, secondTag) => {
        let tmp = modalData
        if (tmp.selectedConfigs.includes(tag)) {
            tmp.selectedConfigs = tmp.selectedConfigs.filter(el => el != tag)
            tmp.selectedConfigsValues = tmp.selectedConfigsValues.filter(el => el != secondTag._id)
        } else {
            tmp.selectedConfigs.push(tag)
            tmp.selectedConfigsValues.push(secondTag._id)
        }
        setModalData({ ...tmp })
    }

    const renderInnerModal = () => {
        if (modalData.status == 'unknown') {
            if (modalData.channels.length == 1) {
                return <div>
                    <p className={style.singleChannelText}>آیا از حذف ساخت اتومات محموله اطمینان دارید؟</p>
                    <div className={style.buttonWrapper}>
                        <div className={style.buttonItem}>
                            <Button
                                disabled={false}
                                tag="delete"
                                type="solid"
                                label="حذف"
                                onclick={() => deleteCargoConfigFunction()}
                            />
                        </div>
                        <div className={style.buttonItem}>
                            <Button
                                disabled={false}
                                tag="cancel"
                                type="outline"
                                label="انصراف"
                                onclick={props.closeModal}
                            />
                        </div>
                    </div>
                </div>
            }
            if (modalData.channels.length > 1) {
                return <div>
                    <p className={style.multiChannelText}>کانال مورد نظر برای حذف ساخت اتومات محموله را انتخاب کنید.</p>
                    <div className={style.multiChannelCheckboxes}>
                        {modalData.channels.map((config, index) => <div key={index} className={style.checkBoxWrapper}>
                            <CheckBox
                                value={modalData.selectedConfigs.includes(config.channel.name + (config.natureType == 'small' ? ' - محموله کوچک' : ' - محموله متوسط و بزرگ')) ? true : false}
                                tag={config.channel.name + (config.natureType == 'small' ? ' - محموله کوچک' : ' - محموله متوسط و بزرگ')}
                                secondTag={config}
                                label={config.channel.name + (config.natureType == 'small' ? ' - محموله کوچک' : ' - محموله متوسط و بزرگ')}
                                onclick={handleCheckBox}
                            />
                        </div>)}
                    </div>
                    {modalData.selectedConfigs.length > 0 && <div className={style.selectedCongisWrapper}>
                        <p>آیا از حذف ساخت اتومات محموله برای کانال {modalData.selectedConfigs.map((channel, index) => <span key={`channel_${index}`}>
                            {channel} {index + 1 !== modalData.selectedConfigs.length ? ' و ' : ' '}
                        </span>)} اطمینان دارید؟</p>
                    </div>}
                    <div className={style.buttonWrapper}>
                        <div className={style.buttonItem}>
                            <Button
                                disabled={false}
                                tag="delete"
                                type="solid"
                                label="حذف"
                                onclick={() => deleteCargoConfigFunction()}
                            />
                        </div>
                        <div className={style.buttonItem}>
                            <Button
                                disabled={false}
                                tag="cancel"
                                type="outline"
                                label="انصراف"
                                onclick={props.closeModal}
                            />
                        </div>
                    </div>
                </div>
            }
        }
        if (modalData.status == 'success') {
            return <div>
                <p className={style.singleChannelText}>ساخت اتومات محموله با موفقیت حذف شد.</p>
                <div className={style.buttonWrapper}>
                    <div className={style.buttonItemDouble}>
                        <Button
                            disabled={false}
                            tag="confirm"
                            type="solid"
                            label="تایید"
                            onclick={props.closeModal}
                        />
                    </div>
                </div>
            </div>
        }
    }

    return (
        <>
            <Modal
                value={props.show}
                title='حذف ساخت اتومات محموله'
                parentClose={props.closeModal}
            >
                <div className={style.wrapper}>
                    {renderInnerModal()}
                </div>
            </Modal>
        </>
    );
}

export default DeleteCargoModal;
